export const stringToBoolean = (str: string): boolean => str === 'true';